import clsx from 'clsx';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { ConnectControls } from './ConnectControls';

export const Header = ({ text }: { text: string }) => {
  const { isMobile } = useCitrusView();
  return (
    <>
      <div
        className={clsx(
          'flex flex-col md:flex-row items-center gap-4 w-[50%] justify-between mb-4',
          {
            '!w-full': isMobile,
          }
        )}
      >
        <h1
          className={clsx('text-3xl whitespace-nowrap', {
            '!text-xl': isMobile,
          })}
        >
          {text}
        </h1>
        <ConnectControls />
        {/*<Button endIcon={<ArrowForward />}>GO TO ACCOUNT</Button>*/}
      </div>
    </>
  );
};
